(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[283,933,53,75],[1155,881,82,113],[904,881,249,50],[167,933,114,50],[632,881,270,50],[0,933,165,50],[0,985,163,50],[355,881,275,50],[0,881,353,50],[165,985,116,50],[0,0,1563,879]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_296 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_295 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_294 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_293 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_292 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_291 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_290 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_289 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_288 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_287 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.LogoRaizesgrande = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,500);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1000), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.sign_out_text = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutText
	this.instance = new lib.CachedBmp_296();
	this.instance.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_text, new cjs.Rectangle(0,0,26.5,37.5), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,2,0,3).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#CAAF6F").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(72,76,84,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#CAAF6F").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-27.5).lineTo(-550,-27.5).moveTo(550,27.5).lineTo(-250,27.5);
	this.shape.setTransform(550,27.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,57), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(1.9,39.1).lineTo(1.9,35.9).lineTo(2.3,35.9).lineTo(2.3,39.1).curveTo(2.3,40.8,3.7,40.8).curveTo(5.2,40.8,5.2,39.1).lineTo(5.2,35.9).lineTo(5.6,35.9).lineTo(5.6,39.1).curveTo(5.6,41.1,3.7,41.1).curveTo(1.9,41.1,1.9,39.1).closePath().moveTo(36,41).lineTo(36,35.9).lineTo(39.1,35.9).lineTo(39.1,36.4).lineTo(36.4,36.4).lineTo(36.4,38.2).lineTo(39,38.2).lineTo(39,38.5).lineTo(36.4,38.5).lineTo(36.4,40.7).lineTo(39.2,40.7).lineTo(39.1,41).closePath().moveTo(31.1,41).lineTo(31.1,36.4).lineTo(29.3,36.4).lineTo(29.3,35.9).lineTo(33.2,35.9).lineTo(33.2,36.4).lineTo(31.5,36.4).lineTo(31.5,41).closePath().moveTo(26,41).lineTo(23,36.4).lineTo(23,41).lineTo(22.6,41).lineTo(22.6,35.9).lineTo(23.2,35.9).lineTo(26.1,40.5).lineTo(26.1,35.9).lineTo(26.5,35.9).lineTo(26.5,41).closePath().moveTo(16.3,41).lineTo(16.3,35.9).lineTo(19.4,35.9).lineTo(19.4,36.4).lineTo(16.7,36.4).lineTo(16.7,38.2).lineTo(19.3,38.2).lineTo(19.3,38.5).lineTo(16.7,38.5).lineTo(16.7,40.7).lineTo(19.5,40.7).lineTo(19.5,41).closePath().moveTo(9.1,41).lineTo(9.1,35.9).lineTo(10.8,35.9).curveTo(11.8,36,12.5,36.6).curveTo(13.1,37.4,13.1,38.4).curveTo(13.1,39.6,12.5,40.3).curveTo(11.8,41.1,10.8,41).closePath().moveTo(9.5,40.7).lineTo(10.7,40.7).curveTo(11.7,40.7,12.2,40.1).curveTo(12.7,39.4,12.7,38.5).curveTo(12.7,37.6,12.3,37).curveTo(11.7,36.4,10.7,36.4).lineTo(9.5,36.4).closePath().moveTo(-1.8,41).lineTo(-1.8,40).lineTo(-1.8,39.9).curveTo(-1.8,39.2,-2.1,39).curveTo(-2.3,38.7,-3.1,38.7).lineTo(-4.3,38.7).lineTo(-4.3,41).lineTo(-4.7,41).lineTo(-4.7,35.9).lineTo(-2.9,35.9).curveTo(-1.3,35.9,-1.3,37.3).curveTo(-1.3,38.2,-2.3,38.5).curveTo(-1.4,38.7,-1.4,39.9).lineTo(-1.4,41).closePath().moveTo(-4.3,38.3).lineTo(-3.1,38.3).curveTo(-1.8,38.3,-1.8,37.3).curveTo(-1.8,36.4,-3,36.4).lineTo(-4.3,36.4).closePath().moveTo(-11.2,41).lineTo(-11.2,35.9).lineTo(-9.3,35.9).curveTo(-8.6,35.9,-8.2,36.4).curveTo(-7.8,36.8,-7.8,37.4).curveTo(-7.8,38.9,-9.4,38.9).lineTo(-10.7,38.9).lineTo(-10.7,41).closePath().moveTo(-10.7,38.5).lineTo(-9.4,38.5).curveTo(-8.2,38.5,-8.2,37.4).curveTo(-8.2,36.4,-9.3,36.4).lineTo(-10.7,36.4).closePath().moveTo(-18.5,41).lineTo(-19.1,39.3).lineTo(-21.3,39.3).lineTo(-21.9,41).lineTo(-22.3,41).lineTo(-20.4,35.9).lineTo(-20,35.9).lineTo(-18,41).closePath().moveTo(-21.1,39).lineTo(-19.3,39).lineTo(-20.2,36.4).closePath().moveTo(-28,41).lineTo(-28,35.9).lineTo(-27.6,35.9).lineTo(-27.6,40.7).lineTo(-24.9,40.7).lineTo(-25,41).closePath().moveTo(-32,41).lineTo(-32,35.9).lineTo(-31.6,35.9).lineTo(-31.6,41).closePath().moveTo(-37.3,41).lineTo(-39.2,35.9).lineTo(-38.8,35.9).lineTo(-37.1,40.7).lineTo(-35.3,35.9).lineTo(-34.9,35.9).lineTo(-36.8,41).closePath().moveTo(34.8,24.9).curveTo(33.9,24.6,33.2,24).curveTo(32.6,23.6,32.1,22.7).curveTo(31.6,21.9,31.6,20.7).lineTo(31.6,11.3).lineTo(30.5,10.8).lineTo(30.5,10.5).lineTo(33.3,10.5).lineTo(33.3,20.7).curveTo(33.3,21.8,33.6,22.6).curveTo(33.9,23.5,34.4,23.9).curveTo(34.9,24.4,35.6,24.6).curveTo(36.3,24.8,37,24.8).curveTo(37.7,24.8,38.6,24.6).curveTo(39.6,24.1,40,23.9).curveTo(40.4,23.5,41,22.8).curveTo(41.4,22.2,41.4,21.4).lineTo(41.4,10.5).lineTo(43,10.5).lineTo(43,24.7).lineTo(42.6,24.7).lineTo(41.5,22.7).curveTo(40.8,23.9,39.4,24.6).curveTo(38,25.2,36.7,25.2).curveTo(35.7,25.2,34.8,24.9).closePath().moveTo(-50.4,24.9).curveTo(-51.3,24.6,-52,24).curveTo(-52.7,23.5,-53.1,22.7).curveTo(-53.6,21.9,-53.6,20.7).lineTo(-53.6,11.3).lineTo(-54.7,10.8).lineTo(-54.7,10.5).lineTo(-51.9,10.5).lineTo(-51.9,20.7).curveTo(-51.9,21.8,-51.6,22.6).curveTo(-51.3,23.5,-50.8,23.9).curveTo(-50.3,24.4,-49.6,24.6).curveTo(-48.9,24.8,-48.2,24.8).curveTo(-47.5,24.8,-46.6,24.6).curveTo(-45.6,24.1,-45.2,23.9).curveTo(-44.8,23.5,-44.2,22.8).curveTo(-43.8,22.2,-43.8,21.4).lineTo(-43.8,10.5).lineTo(-42.2,10.5).lineTo(-42.2,24.7).lineTo(-42.6,24.7).lineTo(-43.7,22.7).curveTo(-44.4,23.9,-45.8,24.6).curveTo(-47.2,25.2,-48.5,25.2).curveTo(-49.5,25.2,-50.4,24.9).closePath().moveTo(47.5,24.6).curveTo(46.1,24.1,45.2,23).lineTo(45.5,22.9).curveTo(46.6,23.9,47.6,24.3).curveTo(48.7,24.8,50.2,24.8).curveTo(51.6,24.8,52.4,24.3).curveTo(53.2,23.8,53.7,23).curveTo(54,22.2,54,21.3).curveTo(53.9,20.6,53.3,20).curveTo(53,19.5,52.1,18.9).lineTo(47.5,17).curveTo(46.4,16.6,46,15.7).curveTo(45.5,14.8,45.6,13.9).curveTo(45.6,13.1,46.1,12.1).curveTo(46.6,11.2,47.5,10.8).curveTo(48.6,10.3,49.9,10.3).curveTo(50.9,10.3,52.1,10.7).curveTo(53.2,11.2,54.1,12).lineTo(53.8,12.2).curveTo(53,11.4,52,11).curveTo(51.2,10.6,49.9,10.6).curveTo(48.8,10.6,47.9,11.2).curveTo(47.1,11.7,46.8,12.6).curveTo(46.5,13.4,46.9,14.3).curveTo(47.4,15.2,48.8,15.8).lineTo(53.1,17.6).curveTo(54.3,18.3,54.7,19.2).curveTo(55.2,20.1,55.1,21.2).curveTo(55.1,22.1,54.6,23.1).curveTo(54.1,24,53.2,24.5).curveTo(51.9,25.1,50.3,25.1).curveTo(49,25.2,47.5,24.6).closePath().moveTo(18.6,24).curveTo(17.1,22.8,16.4,21.2).curveTo(15.6,19.6,15.6,17.6).curveTo(15.6,15.7,16.4,14).curveTo(17.1,12.5,18.6,11.3).curveTo(20,10.2,22.3,10.2).curveTo(24.6,10.2,26,11.3).curveTo(27.5,12.5,28.2,14).curveTo(28.9,15.8,28.9,17.6).curveTo(28.9,19.5,28.2,21.2).curveTo(27.5,22.8,26,24).curveTo(24.6,25.1,22.3,25.1).curveTo(20,25.1,18.6,24).closePath().moveTo(19.5,11.6).curveTo(18.5,12.6,17.8,14.2).curveTo(17.3,15.9,17.3,17.6).curveTo(17.3,19.6,17.8,21.1).curveTo(18.4,22.6,19.5,23.7).curveTo(20.7,24.7,22.3,24.7).curveTo(24,24.7,25.1,23.7).curveTo(26.2,22.6,26.8,21.1).curveTo(27.3,19.4,27.3,17.6).curveTo(27.2,15.5,26.7,14.2).curveTo(26.2,12.7,25.1,11.6).curveTo(24,10.5,22.3,10.5).curveTo(20.7,10.5,19.5,11.6).closePath().moveTo(60.9,24.6).curveTo(59.6,24.1,58.7,23.2).curveTo(57.8,22.4,57.1,20.9).curveTo(56.6,19.5,56.5,17.6).curveTo(56.5,16.1,56.9,14.7).curveTo(57.4,13.4,58.2,12.3).curveTo(59,11.4,60.3,10.7).curveTo(61.6,10.2,63.1,10.2).curveTo(64.3,10.1,65.3,10.5).curveTo(66.4,10.9,67.2,11.6).curveTo(68,12.2,68.6,13.3).curveTo(69.1,14.3,69.1,15.7).lineTo(58.5,15.7).curveTo(58.3,16.5,58.3,17.5).curveTo(58.3,19,58.8,20.5).curveTo(59.3,21.8,60.1,22.7).curveTo(60.9,23.5,62,24).curveTo(63,24.5,64.1,24.5).curveTo(65.3,24.4,66.4,23.9).curveTo(67.5,23.5,68.4,22.4).lineTo(68.7,22.7).curveTo(67.8,23.8,66.3,24.5).curveTo(64.9,25,63.4,25).curveTo(62.2,25.1,60.9,24.6).closePath().moveTo(61.8,11.1).curveTo(61,11.4,60.4,12.1).curveTo(59.6,12.8,59.2,13.5).curveTo(58.8,14.3,58.6,15.3).lineTo(67.3,15.3).curveTo(68.3,15.3,68.4,14.8).curveTo(68.5,14.1,68.1,13.5).curveTo(67.3,11.9,66.2,11.3).curveTo(64.9,10.7,63.7,10.7).curveTo(62.6,10.7,61.8,11.1).closePath().moveTo(-11.5,24.6).curveTo(-12.7,24.1,-13.7,23.2).curveTo(-14.7,22.3,-15.3,20.9).curveTo(-15.9,19.4,-15.9,17.6).curveTo(-15.9,15.9,-15.5,14.7).curveTo(-15,13.4,-14.2,12.3).curveTo(-13.4,11.4,-12.1,10.7).curveTo(-10.9,10.2,-9.3,10.2).curveTo(-8.1,10.1,-7.1,10.5).curveTo(-5.9,10.9,-5.2,11.6).curveTo(-4.3,12.2,-3.8,13.3).curveTo(-3.3,14.3,-3.3,15.7).lineTo(-13.9,15.7).curveTo(-14.1,16.6,-14.1,17.5).curveTo(-14.1,19.3,-13.6,20.5).curveTo(-13.2,21.7,-12.3,22.7).curveTo(-11.5,23.5,-10.4,24).curveTo(-9.4,24.5,-8.3,24.5).curveTo(-7,24.4,-6,23.9).curveTo(-4.9,23.5,-4,22.4).lineTo(-3.7,22.7).curveTo(-4.6,23.8,-6.1,24.5).curveTo(-7.5,25,-9,25).curveTo(-10.3,25.1,-11.5,24.6).closePath().moveTo(-10.6,11.1).curveTo(-11.4,11.4,-12,12.1).curveTo(-12.6,12.6,-13.2,13.5).curveTo(-13.6,14.3,-13.8,15.3).lineTo(-5.1,15.3).curveTo(-4.1,15.3,-4,14.8).curveTo(-3.9,14.2,-4.3,13.5).curveTo(-5.1,11.9,-6.2,11.3).curveTo(-7.5,10.7,-8.7,10.7).curveTo(-9.7,10.7,-10.6,11.1).closePath().moveTo(11.1,24.7).lineTo(11.1,14.2).lineTo(1,14.2).lineTo(1,24.7).lineTo(-0.8,24.7).lineTo(-0.8,5.3).lineTo(-2,4.9).lineTo(-2,4.6).lineTo(1,4.6).lineTo(1,13.7).lineTo(11.1,13.7).lineTo(11.1,4.6).lineTo(12.9,4.6).lineTo(12.9,24.7).closePath().moveTo(-19.4,24.7).lineTo(-19.4,14.6).lineTo(-19.4,14.5).curveTo(-19.4,13.5,-19.7,12.7).curveTo(-19.9,12.1,-20.5,11.4).curveTo(-21.1,11,-21.7,10.8).curveTo(-22.4,10.6,-23,10.5).curveTo(-23.7,10.6,-24.6,10.8).curveTo(-25.4,11,-26,11.5).curveTo(-26.7,11.8,-27.1,12.5).curveTo(-27.5,13.2,-27.5,13.8).lineTo(-27.5,14.1).lineTo(-27.5,24.7).lineTo(-29.1,24.7).lineTo(-29.1,14.5).curveTo(-29,13.4,-29.4,12.6).curveTo(-29.7,11.9,-30.2,11.4).curveTo(-30.6,11,-31.4,10.7).curveTo(-32.1,10.5,-32.8,10.5).curveTo(-33.5,10.5,-34.4,10.7).curveTo(-35.1,10.9,-35.8,11.4).curveTo(-36.5,11.9,-36.8,12.5).curveTo(-37.2,13.1,-37.2,13.9).lineTo(-37.2,24.7).lineTo(-38.9,24.7).lineTo(-38.9,11.3).lineTo(-40,10.8).lineTo(-40,10.5).lineTo(-37.2,10.5).lineTo(-37.2,12.4).curveTo(-36.4,11.3,-35.2,10.6).curveTo(-33.8,10.1,-32.5,10.1).curveTo(-31.1,10.1,-29.7,10.8).curveTo(-28.4,11.5,-27.8,12.9).curveTo(-27,11.4,-25.7,10.8).curveTo(-24.3,10.1,-22.8,10.1).curveTo(-21.8,10.1,-20.9,10.4).curveTo(-19.9,10.8,-19.3,11.3).curveTo(-18.7,11.7,-18.2,12.6).curveTo(-17.8,13.5,-17.8,14.5).lineTo(-17.7,14.5).lineTo(-17.7,24.7).closePath().moveTo(-67.9,24.7).lineTo(-67.9,5.3).lineTo(-69.1,4.9).lineTo(-69.1,4.6).lineTo(-66.1,4.6).lineTo(-66.1,24.2).lineTo(-55.9,24.2).lineTo(-55.9,24.7).closePath().moveTo(-5.7,-8.6).lineTo(-13.9,-8.6).lineTo(-13.9,-16.5).lineTo(-19.6,-22.1).lineTo(-13.9,-27.6).lineTo(-13.9,-35.5).lineTo(-5.7,-35.5).lineTo(0,-41.1).lineTo(5.7,-35.5).lineTo(13.9,-35.5).lineTo(13.9,-27.6).lineTo(19.7,-22.1).lineTo(13.9,-16.5).lineTo(13.9,-8.6).lineTo(5.7,-8.6).lineTo(0,-3.1).closePath().moveTo(-13.4,-27.4).lineTo(-19,-22.1).lineTo(-13.4,-16.7).lineTo(-13.4,-9.1).lineTo(-5.6,-9.1).lineTo(0,-3.8).lineTo(5.6,-9.1).lineTo(13.4,-9.1).lineTo(13.4,-16.7).lineTo(19,-22.1).lineTo(13.4,-27.4).lineTo(13.4,-35.1).lineTo(5.6,-35.1).lineTo(0,-40.4).lineTo(-5.6,-35.1).lineTo(-13.4,-35.1).closePath().moveTo(-4.7,-11).lineTo(-11.4,-11).lineTo(-11.4,-17.5).lineTo(-16.2,-22.1).lineTo(-11.5,-26.6).lineTo(-11.4,-26.7).lineTo(-11.4,-33.1).lineTo(-4.7,-33.1).lineTo(-0.2,-37.4).lineTo(-0.2,-37.6).lineTo(-0.1,-37.6).lineTo(0,-37.7).lineTo(0.1,-37.6).lineTo(0.2,-37.6).lineTo(0.2,-37.5).lineTo(4.7,-33.1).lineTo(11.4,-33.1).lineTo(11.4,-26.7).lineTo(11.5,-26.6).lineTo(16.2,-22.1).lineTo(11.4,-17.5).lineTo(11.4,-11).lineTo(4.7,-11).lineTo(0,-6.5).closePath().moveTo(0.2,-16.8).lineTo(0.2,-7.3).lineTo(4.4,-11.3).lineTo(1.9,-17.1).lineTo(2.1,-17.2).lineTo(2.2,-17.2).lineTo(2.3,-17.3).lineTo(4.8,-11.4).lineTo(10.6,-11.4).lineTo(3.7,-18.2).lineTo(3.8,-18.3).lineTo(3.9,-18.4).lineTo(4,-18.5).lineTo(11,-11.7).lineTo(11,-17.4).lineTo(5,-19.9).lineTo(5,-20).lineTo(5.1,-20.1).lineTo(5.2,-20.2).lineTo(11.2,-17.8).lineTo(15.3,-21.9).lineTo(5.5,-21.9).lineTo(5.5,-22.3).lineTo(15.4,-22.3).lineTo(11.2,-26.4).lineTo(5.1,-23.9).lineTo(5.1,-24).lineTo(5,-24.2).lineTo(5,-24.3).lineTo(5.1,-24.4).lineTo(11,-26.8).lineTo(11,-32.5).lineTo(4,-25.7).lineTo(3.9,-25.7).lineTo(3.8,-25.9).lineTo(3.7,-25.9).lineTo(10.7,-32.7).lineTo(4.8,-32.7).lineTo(2.3,-26.8).lineTo(1.9,-27.1).lineTo(2,-27.2).lineTo(4.4,-32.9).lineTo(0.2,-36.9).lineTo(0.2,-27.4).lineTo(0,-27.4).lineTo(-0,-27.4).lineTo(-0.2,-27.4).lineTo(-0.2,-36.9).lineTo(-4.3,-32.9).lineTo(-1.8,-27.1).lineTo(-2,-27.1).lineTo(-2,-27).lineTo(-2.2,-26.9).lineTo(-4.7,-32.7).lineTo(-10.6,-32.7).lineTo(-3.7,-26).lineTo(-3.8,-25.9).lineTo(-3.9,-25.7).lineTo(-4,-25.7).lineTo(-11,-32.5).lineTo(-11,-26.8).lineTo(-5,-24.3).lineTo(-5,-24.2).lineTo(-5.1,-24).lineTo(-5.1,-23.9).lineTo(-5.2,-23.9).lineTo(-11.1,-26.4).lineTo(-15.4,-22.3).lineTo(-5.5,-22.3).lineTo(-5.5,-21.9).lineTo(-15.3,-21.9).lineTo(-11.2,-17.8).lineTo(-5.1,-20.2).lineTo(-5,-20).lineTo(-5,-19.9).lineTo(-5.1,-19.8).lineTo(-11,-17.4).lineTo(-11,-11.7).lineTo(-4,-18.4).lineTo(-3.9,-18.4).lineTo(-3.7,-18.2).lineTo(-3.8,-18.1).lineTo(-10.7,-11.4).lineTo(-4.6,-11.4).lineTo(-2.2,-17.3).lineTo(-2.1,-17.2).lineTo(-1.8,-17.1).lineTo(-4.3,-11.2).lineTo(-0.2,-7.3).lineTo(-0.2,-16.8).closePath().moveTo(-1,-21.1).lineTo(-2.9,-22.1).lineTo(-1,-23.1).lineTo(0,-25).lineTo(1,-23.1).lineTo(2.9,-22.1).lineTo(1,-21.1).lineTo(0,-19.2).closePath();
	this.shape.setTransform(126.016,27.4176,0.5295,0.5292);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(0.9,19).lineTo(0.9,17.5).lineTo(1.1,17.5).lineTo(1.1,19).curveTo(1.1,19.8,1.8,19.8).curveTo(2.5,19.8,2.5,19).lineTo(2.5,17.5).lineTo(2.7,17.5).lineTo(2.7,19).curveTo(2.7,20,1.8,20).curveTo(0.9,20,0.9,19).closePath().moveTo(17.5,19.9).lineTo(17.5,17.5).lineTo(19,17.5).lineTo(19,17.7).lineTo(17.7,17.7).lineTo(17.7,18.6).lineTo(19,18.6).lineTo(19,18.8).lineTo(17.7,18.8).lineTo(17.7,19.8).lineTo(19.1,19.8).lineTo(19,19.9).closePath().moveTo(15.1,19.9).lineTo(15.1,17.7).lineTo(14.3,17.7).lineTo(14.3,17.5).lineTo(16.1,17.5).lineTo(16.1,17.7).lineTo(15.3,17.7).lineTo(15.3,19.9).closePath().moveTo(12.6,19.9).lineTo(11.2,17.7).lineTo(11.2,19.9).lineTo(11,19.9).lineTo(11,17.5).lineTo(11.3,17.5).lineTo(12.7,19.7).lineTo(12.7,17.5).lineTo(12.9,17.5).lineTo(12.9,19.9).closePath().moveTo(7.9,19.9).lineTo(7.9,17.5).lineTo(9.5,17.5).lineTo(9.5,17.7).lineTo(8.1,17.7).lineTo(8.1,18.6).lineTo(9.4,18.6).lineTo(9.4,18.8).lineTo(8.1,18.8).lineTo(8.1,19.8).lineTo(9.5,19.8).lineTo(9.5,19.9).closePath().moveTo(4.4,19.9).lineTo(4.4,17.5).lineTo(5.2,17.5).curveTo(5.8,17.5,6.1,17.8).curveTo(6.4,18.1,6.4,18.7).curveTo(6.4,19.3,6.1,19.6).curveTo(5.8,19.9,5.2,19.9).closePath().moveTo(4.6,19.8).lineTo(5.2,19.8).curveTo(5.7,19.8,6,19.5).curveTo(6.2,19.2,6.2,18.7).curveTo(6.2,18.3,6,18).curveTo(5.7,17.7,5.2,17.7).lineTo(4.6,17.7).closePath().moveTo(-0.9,19.9).lineTo(-0.9,19.5).lineTo(-0.9,19.4).curveTo(-0.9,19.3,-0.9,19.3).curveTo(-0.9,19.2,-0.9,19.1).curveTo(-0.9,19.1,-1,19).curveTo(-1,19,-1,18.9).curveTo(-1,18.9,-1.1,18.9).curveTo(-1.1,18.9,-1.2,18.8).curveTo(-1.2,18.8,-1.3,18.8).curveTo(-1.4,18.8,-1.5,18.8).lineTo(-2.1,18.8).lineTo(-2.1,19.9).lineTo(-2.3,19.9).lineTo(-2.3,17.5).lineTo(-1.4,17.5).curveTo(-0.6,17.5,-0.6,18.1).curveTo(-0.6,18.6,-1.1,18.7).curveTo(-0.7,18.8,-0.7,19.4).lineTo(-0.7,19.9).closePath().moveTo(-2.1,18.6).lineTo(-1.5,18.6).curveTo(-0.9,18.6,-0.9,18.1).curveTo(-0.9,17.7,-1.4,17.7).lineTo(-2.1,17.7).closePath().moveTo(-5.4,19.9).lineTo(-5.4,17.5).lineTo(-4.5,17.5).curveTo(-4.2,17.5,-4,17.7).curveTo(-3.8,17.8,-3.8,18.2).curveTo(-3.8,18.9,-4.6,18.9).lineTo(-5.2,18.9).lineTo(-5.2,19.9).closePath().moveTo(-5.2,18.7).lineTo(-4.6,18.7).curveTo(-4,18.7,-4,18.2).curveTo(-4,17.6,-4.5,17.7).lineTo(-5.2,17.7).closePath().moveTo(-9,19.9).lineTo(-9.3,19.1).lineTo(-10.4,19.1).lineTo(-10.6,19.9).lineTo(-10.9,19.9).lineTo(-9.9,17.5).lineTo(-9.7,17.5).lineTo(-8.8,19.9).closePath().moveTo(-10.3,18.9).lineTo(-9.4,18.9).lineTo(-9.8,17.7).closePath().moveTo(-13.6,19.9).lineTo(-13.6,17.5).lineTo(-13.4,17.5).lineTo(-13.4,19.8).lineTo(-12.1,19.8).lineTo(-12.2,19.9).closePath().moveTo(-15.6,19.9).lineTo(-15.6,17.5).lineTo(-15.4,17.5).lineTo(-15.4,19.9).closePath().moveTo(-18.2,19.9).lineTo(-19.1,17.5).lineTo(-18.9,17.5).lineTo(-18,19.8).lineTo(-17.2,17.5).lineTo(-17,17.5).lineTo(-17.9,19.9).closePath().moveTo(17,12.1).lineTo(16.2,11.7).curveTo(15.9,11.4,15.6,11).curveTo(15.4,10.6,15.4,10.1).lineTo(15.4,5.5).lineTo(14.8,5.3).lineTo(14.8,5.1).lineTo(16.2,5.1).lineTo(16.2,10.1).curveTo(16.2,10.6,16.3,11).lineTo(16.7,11.6).lineTo(17.3,11.9).lineTo(18,12).lineTo(18.8,11.9).lineTo(19.5,11.6).lineTo(20,11).curveTo(20.1,10.8,20.1,10.4).lineTo(20.1,5.1).lineTo(20.9,5.1).lineTo(20.9,12).lineTo(20.7,12).lineTo(20.2,11).curveTo(19.8,11.6,19.2,11.9).curveTo(18.5,12.2,17.9,12.3).curveTo(17.4,12.3,17,12.1).closePath().moveTo(-24.5,12.1).curveTo(-25,12,-25.3,11.7).curveTo(-25.7,11.4,-25.9,11).curveTo(-26.1,10.6,-26.1,10.1).lineTo(-26.1,5.5).lineTo(-26.6,5.3).lineTo(-26.6,5.1).lineTo(-25.3,5.1).lineTo(-25.3,10.1).curveTo(-25.3,10.6,-25.1,11).curveTo(-25,11.4,-24.7,11.6).curveTo(-24.5,11.9,-24.2,11.9).lineTo(-23.5,12).lineTo(-22.7,11.9).lineTo(-22,11.6).curveTo(-21.8,11.5,-21.5,11).curveTo(-21.3,10.8,-21.3,10.4).lineTo(-21.3,5.1).lineTo(-20.5,5.1).lineTo(-20.5,12).lineTo(-20.7,12).lineTo(-21.3,11).curveTo(-21.6,11.6,-22.3,11.9).curveTo(-23,12.2,-23.6,12.3).lineTo(-24.5,12.1).closePath().moveTo(29.6,11.9).curveTo(29,11.7,28.6,11.3).curveTo(28.1,10.9,27.8,10.1).curveTo(27.5,9.5,27.5,8.5).curveTo(27.5,7.8,27.7,7.2).curveTo(27.9,6.5,28.3,6).curveTo(28.7,5.5,29.3,5.2).curveTo(30,4.9,30.7,4.9).curveTo(31.3,4.9,31.8,5.1).curveTo(32.3,5.3,32.7,5.6).curveTo(33.1,5.9,33.4,6.4).curveTo(33.6,6.9,33.6,7.6).lineTo(28.5,7.6).lineTo(28.4,8.5).curveTo(28.4,9.2,28.6,10).curveTo(28.9,10.6,29.3,11).curveTo(29.6,11.5,30.2,11.7).curveTo(30.7,11.9,31.2,11.9).curveTo(31.8,11.9,32.3,11.7).curveTo(32.9,11.4,33.3,10.9).lineTo(33.5,11).curveTo(33,11.6,32.3,11.9).curveTo(31.6,12.2,30.9,12.2).curveTo(30.3,12.2,29.6,11.9).closePath().moveTo(30.1,5.4).lineTo(29.4,5.8).curveTo(29,6.2,28.8,6.6).lineTo(28.5,7.4).lineTo(32.7,7.4).curveTo(33.2,7.4,33.3,7.2).curveTo(33.3,6.8,33.2,6.5).curveTo(32.8,5.8,32.2,5.5).curveTo(31.6,5.2,31,5.2).curveTo(30.5,5.2,30.1,5.4).closePath().moveTo(23.1,11.9).curveTo(22.5,11.7,22,11.2).lineTo(22.1,11.1).curveTo(22.7,11.6,23.2,11.8).curveTo(23.7,12,24.4,12).curveTo(25.1,12,25.5,11.8).lineTo(26.1,11.2).lineTo(26.3,10.4).curveTo(26.2,10,26,9.7).curveTo(25.8,9.5,25.3,9.2).lineTo(23.1,8.3).curveTo(22.6,8,22.4,7.6).curveTo(22.2,7.2,22.2,6.7).curveTo(22.2,6.4,22.4,5.8).curveTo(22.7,5.4,23.1,5.3).curveTo(23.7,5,24.3,5).curveTo(24.8,5,25.4,5.2).curveTo(25.9,5.4,26.3,5.8).lineTo(26.2,6).curveTo(25.8,5.5,25.3,5.4).curveTo(24.9,5.2,24.3,5.2).curveTo(23.7,5.2,23.3,5.4).curveTo(22.9,5.7,22.8,6.1).curveTo(22.6,6.5,22.8,7).curveTo(23.1,7.4,23.8,7.6).lineTo(25.9,8.5).curveTo(26.4,8.9,26.6,9.3).curveTo(26.9,9.7,26.8,10.3).curveTo(26.8,10.7,26.6,11.2).curveTo(26.3,11.6,25.9,11.9).curveTo(25.3,12.2,24.5,12.2).curveTo(23.9,12.2,23.1,11.9).closePath().moveTo(9,11.7).curveTo(8.3,11.1,8,10.3).curveTo(7.6,9.5,7.6,8.5).curveTo(7.6,7.7,8,6.8).curveTo(8.3,6,9,5.5).curveTo(9.7,4.9,10.8,4.9).curveTo(12,4.9,12.6,5.5).curveTo(13.4,6,13.7,6.8).curveTo(14.1,7.7,14.1,8.5).curveTo(14.1,9.5,13.7,10.3).curveTo(13.4,11.1,12.6,11.7).curveTo(12,12.2,10.8,12.2).curveTo(9.7,12.2,9,11.7).closePath().moveTo(9.5,5.6).curveTo(9,6.1,8.7,6.9).curveTo(8.4,7.7,8.4,8.5).curveTo(8.4,9.5,8.7,10.2).curveTo(9,11,9.5,11.5).curveTo(10.1,12,10.8,12).curveTo(11.7,12,12.2,11.5).curveTo(12.7,11,13,10.2).curveTo(13.3,9.5,13.3,8.5).curveTo(13.3,7.6,13,6.9).curveTo(12.7,6.2,12.2,5.6).curveTo(11.7,5.1,10.8,5.1).curveTo(10.1,5.1,9.5,5.6).closePath().moveTo(-5.6,11.9).curveTo(-6.2,11.7,-6.7,11.3).curveTo(-7.1,10.9,-7.4,10.1).curveTo(-7.7,9.5,-7.7,8.5).curveTo(-7.7,7.7,-7.5,7.2).curveTo(-7.3,6.5,-6.9,6).curveTo(-6.5,5.5,-5.9,5.2).curveTo(-5.3,4.9,-4.5,4.9).lineTo(-3.4,5.1).curveTo(-2.9,5.3,-2.5,5.6).curveTo(-2.1,5.9,-1.9,6.4).curveTo(-1.6,6.9,-1.6,7.6).lineTo(-6.8,7.6).lineTo(-6.9,8.5).curveTo(-6.9,9.4,-6.6,10).curveTo(-6.4,10.6,-6,11).curveTo(-5.6,11.5,-5.1,11.7).curveTo(-4.6,11.9,-4,11.9).curveTo(-3.4,11.9,-2.9,11.7).curveTo(-2.4,11.4,-1.9,10.9).lineTo(-1.8,11).curveTo(-2.3,11.6,-3,11.9).curveTo(-3.6,12.2,-4.4,12.2).curveTo(-5,12.2,-5.6,11.9).closePath().moveTo(-5.1,5.4).lineTo(-5.9,5.8).lineTo(-6.4,6.6).lineTo(-6.7,7.4).lineTo(-2.5,7.4).curveTo(-2,7.4,-2,7.2).curveTo(-1.9,6.9,-2.1,6.5).curveTo(-2.5,5.8,-3,5.5).curveTo(-3.6,5.2,-4.2,5.2).curveTo(-4.7,5.2,-5.1,5.4).closePath().moveTo(5.4,12).lineTo(5.4,6.9).lineTo(0.5,6.9).lineTo(0.5,12).lineTo(-0.4,12).lineTo(-0.4,2.6).lineTo(-1,2.4).lineTo(-1,2.2).lineTo(0.5,2.2).lineTo(0.5,6.6).lineTo(5.4,6.6).lineTo(5.4,2.2).lineTo(6.3,2.2).lineTo(6.3,12).closePath().moveTo(-9.4,12).lineTo(-9.4,7.1).lineTo(-9.5,7.1).curveTo(-9.4,6.5,-9.6,6.2).curveTo(-9.7,5.9,-10,5.5).curveTo(-10.3,5.3,-10.5,5.3).lineTo(-11.2,5.1).lineTo(-12,5.3).curveTo(-12.4,5.3,-12.7,5.6).curveTo(-13,5.7,-13.2,6.1).curveTo(-13.4,6.4,-13.4,6.7).lineTo(-13.4,12).lineTo(-14.2,12).lineTo(-14.2,7.1).curveTo(-14.1,6.5,-14.3,6.2).curveTo(-14.4,5.8,-14.7,5.5).lineTo(-15.3,5.2).lineTo(-16,5.1).lineTo(-16.7,5.2).lineTo(-17.4,5.5).lineTo(-17.9,6.1).curveTo(-18.1,6.4,-18.1,6.7).lineTo(-18.1,12).lineTo(-18.9,12).lineTo(-18.9,5.5).lineTo(-19.5,5.3).lineTo(-19.5,5.1).lineTo(-18.1,5.1).lineTo(-18.1,6).curveTo(-17.7,5.5,-17.1,5.2).curveTo(-16.5,4.9,-15.8,4.9).curveTo(-15.1,4.9,-14.4,5.3).curveTo(-13.8,5.6,-13.5,6.3).curveTo(-13.1,5.5,-12.5,5.3).curveTo(-11.8,4.9,-11.1,4.9).curveTo(-10.6,4.9,-10.2,5.1).curveTo(-9.7,5.2,-9.4,5.4).curveTo(-9.1,5.7,-8.8,6.1).curveTo(-8.7,6.6,-8.7,7.1).lineTo(-8.6,7.1).lineTo(-8.6,12).closePath().moveTo(-33,12).lineTo(-33,2.6).lineTo(-33.6,2.4).lineTo(-33.6,2.2).lineTo(-32.2,2.2).lineTo(-32.2,11.7).lineTo(-27.2,11.7).lineTo(-27.2,12).closePath().moveTo(-2.8,-4.2).lineTo(-6.8,-4.2).lineTo(-6.8,-8).lineTo(-9.6,-10.8).lineTo(-6.8,-13.5).lineTo(-6.8,-17.3).lineTo(-2.8,-17.3).lineTo(0,-20).lineTo(2.8,-17.3).lineTo(6.8,-17.3).lineTo(6.8,-13.5).lineTo(9.6,-10.8).lineTo(6.8,-8).lineTo(6.8,-4.2).lineTo(2.8,-4.2).lineTo(0,-1.5).closePath().moveTo(-6.5,-13.4).lineTo(-9.2,-10.8).lineTo(-6.5,-8.1).lineTo(-6.5,-4.5).lineTo(-2.7,-4.5).lineTo(0,-1.8).lineTo(2.7,-4.5).lineTo(6.5,-4.5).lineTo(6.5,-8.1).lineTo(9.2,-10.8).lineTo(6.5,-13.4).lineTo(6.5,-17.1).lineTo(2.7,-17.1).lineTo(0,-19.7).lineTo(-2.7,-17.1).lineTo(-6.5,-17.1).closePath().moveTo(-2.3,-5.4).lineTo(-5.6,-5.4).lineTo(-5.6,-8.6).lineTo(-7.9,-10.8).lineTo(-5.6,-12.9).lineTo(-5.6,-16.1).lineTo(-2.3,-16.1).lineTo(-0.1,-18.2).lineTo(-0.1,-18.3).lineTo(-0,-18.3).lineTo(0,-18.3).lineTo(0.1,-18.3).lineTo(0.1,-18.3).lineTo(0.1,-18.2).lineTo(2.3,-16.1).lineTo(5.6,-16.1).lineTo(5.6,-12.9).lineTo(7.9,-10.8).lineTo(5.6,-8.6).lineTo(5.6,-5.4).lineTo(2.3,-5.4).lineTo(0,-3.2).closePath().moveTo(0.1,-8.2).lineTo(0.1,-3.5).lineTo(2.1,-5.5).lineTo(0.9,-8.3).lineTo(1,-8.4).lineTo(1.1,-8.4).lineTo(2.3,-5.6).lineTo(5.2,-5.6).lineTo(1.8,-8.9).lineTo(2,-9).lineTo(5.4,-5.7).lineTo(5.4,-8.5).lineTo(2.4,-9.7).lineTo(2.4,-9.7).lineTo(2.5,-9.8).lineTo(2.5,-9.9).lineTo(5.4,-8.7).lineTo(7.5,-10.7).lineTo(2.7,-10.7).lineTo(2.7,-10.8).lineTo(7.5,-10.8).lineTo(5.4,-12.8).lineTo(2.5,-11.6).lineTo(2.5,-11.7).lineTo(2.4,-11.8).lineTo(2.4,-11.8).lineTo(2.5,-11.8).lineTo(5.4,-13.1).lineTo(5.4,-15.9).lineTo(2,-12.5).lineTo(1.8,-12.6).lineTo(5.2,-16).lineTo(2.3,-16).lineTo(1.1,-13.1).lineTo(0.9,-13.2).lineTo(1,-13.3).lineTo(2.2,-16).lineTo(0.1,-18).lineTo(0.1,-13.3).lineTo(0,-13.4).lineTo(-0,-13.4).lineTo(-0.1,-13.3).lineTo(-0.1,-18).lineTo(-2.1,-16).lineTo(-0.9,-13.2).lineTo(-1,-13.2).lineTo(-1,-13.2).lineTo(-1.1,-13.1).lineTo(-2.3,-16).lineTo(-5.2,-16).lineTo(-1.8,-12.6).lineTo(-2,-12.5).lineTo(-5.4,-15.8).lineTo(-5.4,-13.1).lineTo(-2.4,-11.8).lineTo(-2.4,-11.8).lineTo(-2.5,-11.7).lineTo(-2.5,-11.6).lineTo(-2.5,-11.6).lineTo(-5.4,-12.8).lineTo(-7.5,-10.8).lineTo(-2.7,-10.8).lineTo(-2.7,-10.7).lineTo(-7.5,-10.7).lineTo(-5.4,-8.7).lineTo(-2.5,-9.9).lineTo(-2.4,-9.7).lineTo(-2.4,-9.7).lineTo(-2.5,-9.7).lineTo(-5.4,-8.5).lineTo(-5.4,-5.7).lineTo(-2,-9).lineTo(-1.8,-8.9).lineTo(-1.8,-8.8).lineTo(-5.2,-5.6).lineTo(-2.3,-5.6).lineTo(-1.1,-8.4).lineTo(-1,-8.4).lineTo(-0.9,-8.3).lineTo(-2.1,-5.4).lineTo(-0.1,-3.5).lineTo(-0.1,-8.2).closePath().moveTo(-0.5,-10.2).lineTo(-1.4,-10.8).lineTo(-0.5,-11.3).lineTo(0,-12.2).lineTo(0.5,-11.3).lineTo(1.4,-10.8).lineTo(0.5,-10.2).lineTo(0,-9.3).closePath();
	this.shape_1.setTransform(125.025,27.4);

	this.instance = new lib.LogoRaizesgrande();
	this.instance.setTransform(77.05,0,0.0626,0.0626);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.instance}]},1).wait(1));

	// size
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-125,27.8).lineTo(-125,10.4).lineTo(-116.4,10.4).lineTo(-116.4,-27.8).lineTo(125,-27.8).lineTo(125,27.8).closePath();
	this.shape_2.setTransform(125,27.825);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,250,55.7);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1212.7,12.4);

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1085.2,12.4);

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(958.6,12.4);

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(737,12.4);

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(554.6,12.4);

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(374.7,12.4);

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(250.1,12.4);

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(80.6,12.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_8 = new lib.square();
	this.instance_8.setTransform(1215.7,13);
	this.instance_8.visible = false;

	this.instance_9 = new lib.square();
	this.instance_9.setTransform(1071.5,13);
	this.instance_9.visible = false;

	this.instance_10 = new lib.square();
	this.instance_10.setTransform(833.4,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(1410.4,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(634.5,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(450.8,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(273.8,13);
	this.instance_14.visible = false;

	this.instance_15 = new lib.square();
	this.instance_15.setTransform(88,13);
	this.instance_15.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8}]}).wait(1));

	// ball
	this.instance_16 = new lib.ball();
	this.instance_16.setTransform(1417.4,13);
	this.instance_16.visible = false;

	this.instance_17 = new lib.ball();
	this.instance_17.setTransform(1242.8,13);
	this.instance_17.visible = false;

	this.instance_18 = new lib.ball();
	this.instance_18.setTransform(1116.4,13);
	this.instance_18.visible = false;

	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(934.1,13);
	this.instance_19.visible = false;

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(773.7,13);
	this.instance_20.visible = false;

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(606.6,13);
	this.instance_21.visible = false;

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(428.5,13);
	this.instance_22.visible = false;

	this.instance_23 = new lib.ball();
	this.instance_23.setTransform(259.3,13);
	this.instance_23.visible = false;

	this.instance_24 = new lib.ball();
	this.instance_24.setTransform(79.7,13);
	this.instance_24.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]}).wait(1));

	// title
	this.instance_25 = new lib.sign_out_text();
	this.instance_25.setTransform(1530.25,10.8,1,1,0,0,0,13.2,18.7);

	this.instance_26 = new lib.CachedBmp_295();
	this.instance_26.setTransform(1508.45,-15.95,0.5,0.5);

	this.instance_27 = new lib.CachedBmp_294();
	this.instance_27.setTransform(120.85,0,0.5,0.5);

	this.instance_28 = new lib.CachedBmp_293();
	this.instance_28.setTransform(1234.75,0,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_292();
	this.instance_29.setTransform(308.1,0,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_291();
	this.instance_30.setTransform(1089.4,0,0.5,0.5);

	this.instance_31 = new lib.CachedBmp_290();
	this.instance_31.setTransform(945.05,0,0.5,0.5);

	this.instance_32 = new lib.CachedBmp_289();
	this.instance_32.setTransform(505.65,0,0.5,0.5);

	this.instance_33 = new lib.CachedBmp_288();
	this.instance_33.setTransform(705.8,0,0.5,0.5);

	this.instance_34 = new lib.CachedBmp_287();
	this.instance_34.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,-15.9,1549.5,56.5), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(2).to({y:0},8).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,2);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,27.5).lineTo(-960,-27.5).lineTo(960,-27.5).lineTo(960,27.5).closePath();
	this.shape.setTransform(960,27.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,58), null);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11,frame12:12,frame13:13};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#543228").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);
	this.shape._off = true;

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,525).lineTo(-960,-525).lineTo(960,-525).lineTo(960,525).closePath();
	this.shape_1.setTransform(960,525);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#543228").beginStroke().moveTo(-960,15).lineTo(-960,-15).lineTo(960,-15).lineTo(960,15).closePath();
	this.shape_2.setTransform(960,1065);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,525).lineTo(-960,481.6).lineTo(960,481.6).lineTo(960,525).closePath().moveTo(-960,471.6).lineTo(-960,-525).lineTo(960,-525).lineTo(960,471.6).closePath();
	this.shape_3.setTransform(960,525);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.beginFill("#543228").beginStroke().moveTo(-960,41.7).lineTo(-960,11.7).lineTo(960,11.7).lineTo(960,41.7).closePath().moveTo(-960,-31.7).lineTo(-960,-41.7).lineTo(960,-41.7).lineTo(960,-31.7).closePath();
	this.shape_4.setTransform(960,1038.275);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_2},{t:this.shape_1}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_4},{t:this.shape_3}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_4},{t:this.shape_3}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape}]},1).to({state:[]},1).wait(3));
	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2).to({_off:false},0).to({_off:true},1).wait(1).to({_off:false},0).wait(1).to({_off:true},1).wait(1).to({_off:false},0).to({_off:true},1).wait(1).to({_off:false},0).wait(1).to({_off:true},1).wait(3));

	// size
	this.instance = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(14));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart('index', 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete('index', 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd('index', 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(2).to({alpha:0},8).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1000);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:175.25},0).wait(1).to({x:322.1},0).wait(1).to({x:474.05},0).wait(1).to({x:654.65},0).wait(1).to({x:856.15},0).wait(1).to({x:1030},0).wait(1).to({x:1156.8},0).wait(1).to({x:1271.1},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(11));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1293.7,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.btSair.addEventListener("click", fl_ClickToGoToWebPage2);
		
		function fl_ClickToGoToWebPage2() {
			window.open("http://127.0.0.1/portal-terra-web", "_self");
		}
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// button
	this.btSair = new lib.button();
	this.btSair.name = "btSair";
	this.btSair.setTransform(1898.85,1036.95,0.3423,0.601,0,0,0,0.8,0.2);
	new cjs.ButtonHelper(this.btSair, 0, 1, 2, false, new lib.button(), 3);

	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.698)").beginStroke().moveTo(-52.4,24.1).lineTo(-52.4,-24.1).lineTo(52.4,-24.1).lineTo(52.4,24.1).closePath();
	this.shape.setTransform(682.1148,1147.5061,0.9508,1.1434);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1631.45,1029.8,0.5983,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1500.3,1030.05,0.8006,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1352.5,1030.05,0.7936,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1166.9,1030.05,1.5358,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(945.15,1030.05,1.2256,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(745.55,1030.05,1.2096,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(682.25,1146.05,0.7781,0.4688,0,0,0,0.2,0.1);
	this.btn_page04.visible = false;
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(554.5,1030.05,1.1296,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(399.2,1029.9,0.6109,0.4687,0,0,0,0.2,0.3);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page10},{t:this.shape},{t:this.btSair}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(93.2,1040.05,0.9375,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(360,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(399.1,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1712.15,1086.5,0.6665,0.6667,0,0,0,0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// title
	this.instance_1 = new lib.title();
	this.instance_1.setTransform(370,1015.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// logo
	this.occ_logo = new lib.logo();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(60,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_2 = new lib.background();
	this.instance_2.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_3 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,0,1924,1176), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, 'index');
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1175);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png?1746813882916", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
